import { createRouter, createWebHistory } from "vue-router";
import HomeView from "./views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
  },
  {
    path: "/help",
    name: "HelpView",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "help" */ "@/views/HelpView.vue"),
  },
  {
    path: "/voiceList",
    name: "VoiceListView",
    component: () => import(/* webpackChunkName: "voiceList" */ "@/views/VoiceListView.vue"),
  },
  {
    path: "/webmaster",
    name: "WebmasterView",
    component: () => import(/* webpackChunkName: "webmaster" */ "@/views/WebmasterView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
